import {Component, OnInit, ViewChild} from '@angular/core';
import {BreadcrumbParent} from "../../../shared/breadcrumb/breadcrumb/breadcrumb.component";
import {TranslateService} from "@ngx-translate/core";
import {
  ColonnadeInsuranceListComponent,
  ColonnadeInsuranceListType
} from "../colonnade-insurance-list/colonnade-insurance-list.component";
import {RightModel} from "../../../app.rights";
import {RightResolver, RightService} from "../../../lib/right.service";

@Component({
  selector: 'app-colonnade-insurance-list-container',
  templateUrl: './colonnade-insurance-list-container.component.html',
  styleUrls: ['./colonnade-insurance-list-container.component.scss']
})
export class ColonnadeInsuranceListContainerComponent implements OnInit {
  ColonnadeInsuranceListType=ColonnadeInsuranceListType;
  breadcrumbParents: BreadcrumbParent[] = [];
  breadcrumbSelf: string;
  compactSidebar: boolean = document.querySelector('body')!.classList.contains('sidebar-compact');
  rightModel: RightModel = RightModel.empty();
  @ViewChild("submittedList") submittedList: ColonnadeInsuranceListComponent;

  constructor(private translateService: TranslateService,
  private rightService: RightService) { }

  ngOnInit(): void {
    this.initBreadcrumb();
    this.loadRightModel();

  }

  private initBreadcrumb() {
    this.translateService.get('INSURANCE_LIST').subscribe(
      (result: string) => {
        this.breadcrumbSelf = result;
      }
    );
  }

  private loadRightModel() {
    this.rightService.getRightResolver().subscribe(
      (resolver: RightResolver) => {
        this.rightModel = RightModel.of(resolver);
      }
    );
  }


}
